import { FormAddressType } from './form-address-type.enum'

export const isAutoForm = (form: FormAddressType): boolean =>
  form === FormAddressType.AUTO
